import { render } from "./SendUsMessage.vue?vue&type=template&id=1d1d43b6&ts=true"
import script from "./SendUsMessage.vue?vue&type=script&lang=ts"
export * from "./SendUsMessage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__